// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"3dcbde71","370":"0f24cb31","399":"8cdf97e5","619":"78ddfe65","727":"448b0c7a","732":"023a483a","803":"566b8d68","877":"b42f5549"}[chunkId] + ".chunk.js";
};